// @flow

export function getRandomBackgroundClass() {
  const ran = Math.floor(Math.random() * (2 - 1 + 1)) + 1
  let kls = 'one'
  if (ran === 2) {
    kls = 'two'
  }

  return kls
}

export function createHtmlElement(html: string): Object {
  return { __html: html }
}

export function getUrlParameter(name: string) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]')
  let regex = new RegExp('[\\?&]' + name + '=([^&#]*)')
  let results = regex.exec(window.location.search)
  return results === null
    ? null
    : decodeURIComponent(results[1].replace(/\+/g, ' '))
}

export function getPusherApiKey(): string {
  return process.env.REACT_APP_PUSHER_API_KEY
}

export function getLoggingToken(): string {
  return process.env.REACT_APP_LOGGING_TOKEN
}

export function getLoggingProjectId(): number {
  return process.env.REACT_APP_LOGGING_PROJECT_ID
}

export function isLocalHost(): boolean {
  const hostname = window.location.hostname
  return !!(
    hostname === 'localhost' ||
    hostname === 'development-quest.questforward.org' ||
    hostname === '[::1]' ||
    hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
  )
}

export const groupItemBy = (array, property) => {
  let hash = {}
  let props = property.split('.')
  for (let i = 0; i < array.length; i++) {
    let key = props.reduce(function (acc, prop) {
      return acc && acc[prop]
    }, array[i])
    if (!hash[key]) hash[key] = []
    hash[key].push(array[i])
  }

  return hash
}

export function isNullOrEmpty(val) {
  return !val || val === ''
}
